import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestGroup } from 'src/app/models/custom_test_model';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
declare var Quill: any;

@Component({
  selector: 'app-create-test-group',
  templateUrl: './create-test-group.component.html',
  styleUrls: ['./create-test-group.component.css']
})
export class CreateTestGroupComponent implements OnInit {

  public infoEditor: any;
  public editingId: string = '';
  public group: TestGroup = {
    title: '',
    info: {},
    active: false,
    description: '',
    userId: '',
    testsQuantity: 0,
    questionsQuantity: 0
  }

  public user;

  constructor(
    private customTestService: CustomTestService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService
  ) { }

  async ngOnInit() {
    let editingId = this.route.snapshot.queryParamMap.get('editingId')
    this.user = await this.userService.getUser().toPromise()
    if (editingId){
      this.editingId = editingId
      this.customTestService.getTestGroups({_id: editingId}).subscribe((res:any)=>{
        this.group = res[0]
        setTimeout(() => {
          this.initEditors()
          this.infoEditor.setContents(this.group.info)
        }, 1000)
      })
    }else{
      setTimeout(() => {
        this.initEditors()
      }, 1000)
    }
  }

  initEditors(){
    var toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
    
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
    
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'align': [] }],
      ['link'],
    
    ];
    var options = {
      modules: {
        toolbar: toolbarOptions
      },
      placeholder: 'Content here...',
      theme: 'snow'
    };
    this.infoEditor = new Quill('.info-editor', options)


  }

  create(){
    if (this.user.role != 'admin'){
      this.group.userId = this.user._id
    }
    this.group.info = this.infoEditor.getContents()
    if (!this.editingId){
      this.customTestService.createTestGroup(this.group).subscribe((res:any)=>{
        Swal.fire({
          text: 'Grupo creado correctamente',
          icon: 'success'
        }).then(()=>{
          this.router.navigate[('/dashboard/test-groups')]  
        })
      })
    }else{
      this.customTestService.updateTestGroup(this.group, this.editingId).subscribe((res:any)=>{
        Swal.fire({
          text: 'Grupo actualizado correctamente',
          icon: 'success'
        })
      })
    }
  }

}
